import { EventSubscriber } from '@a-type/utils';
export const gestureEvents = new EventSubscriber();
//# sourceMappingURL=gestureEvents.js.map